import {
	Box,
	Button,
	IconButton,
	InputAdornment,
	TextField,
	Alert,
	Snackbar,
	createSvgIcon,
	Typography,
	Divider,
	useMediaQuery,
	Stack,
	Icon,
	Paper,
	Link,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import useStyle from "./styles";

import LinkedInIcon from "@mui/icons-material/LinkedIn";

import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import { ReactComponent as GoogleLogo } from "../../assets/icons/google.svg";
import logo from "../../assets/icons/logoCactusDark.png";

import {
	Facebook,
	Instagram,
	Language,
	LinkedIn,
	Person2Outlined,
	Visibility,
	VisibilityOff,
	VisibilityOffOutlined,
	VisibilityOutlined,
} from "@mui/icons-material";
import React, { useState } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";

export default function Login() {
	const theme = useTheme();
	const styles = useStyle(theme);
	const GoogleIcon = createSvgIcon(<GoogleLogo />);
	const [showPassword, setShowPassword] = useState(false);
	const [login, setLogin] = useState("");
	const [senha, setSenha] = useState("");
	const [alertOpen, setAlertOpen] = useState(false);
	const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));

	const [Null, setNull] = useState(false);
	const [snackbar, setSnackbar] = useState(null);
	const [loading, setLoading] = useState(false);
	const [alert, setAlert] = useState(false);
	const navigate = useNavigate();
	const [shrink, setShrink] = useState(false);
	const [passShrink, setPassShrink] = useState(false);

	// limita o keydown no campo senha
	const [enterFlag, setEnterFlag] = useState(false);

	const url = `${
		window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || ""
	}`;
	//img background
	const urlLoginImg = `${
		window?.config?.REACT_APP_LOGIN_IMG_INTERNO ||
		process.env.REACT_APP_LOGIN_IMG_INTERNO ||
		""
	}`;
	//img logo
	const logoInternoDark = `${
		window?.config?.REACT_APP_LOGO_INTERNO_DARK ||
		process.env.REACT_APP_LOGO_INTERNO_DARK ||
		""
	}`;
	const logoInternoLight = `${
		window?.config?.REACT_APP_LOGO_INTERNO_LIGHT ||
		process.env.REACT_APP_LOGO_INTERNO_LIGHT ||
		""
	}`;

	//radesociais
	const urlFacebook = `${
		window?.config?.REACT_APP_URL_FACEBOOK ||
		process.env.REACT_APP_URL_FACEBOOK ||
		""
	}`;
	const urlInstagram = `${
		window?.config?.REACT_APP_URL_INSTAGRAM ||
		process.env.REACT_APP_URL_INSTAGRAM ||
		""
	}`;
	const urlLinkedin = `${
		window?.config?.REACT_APP_URL_LINKEDIN ||
		process.env.REACT_APP_URL_LINKEDIN ||
		""
	}`;

	const handleLogin = async () => {
		if (!login || !senha) {
			setNull(true);
			return;
		}

		setLoading(!login || !senha);
		try {
			const response = await axios.post(
				`${url}/login`,
				{ login, senha },
				{ withCredentials: false },
			);

			if (response?.data?.token) {
				const { perfil, logs, acessoClienteId, ...userData } = response.data;
				localStorage.clear();
				if (response.data.usuario?.status) {
					localStorage.setItem("user", JSON.stringify(userData));
					if (perfil) localStorage.setItem("perfil", JSON.stringify(perfil));
					localStorage.setItem("logs", JSON.stringify(logs));
				}

				if (
					response.data.usuario?.status == true &&
					response.data.perfilAlreadyExists === true &&
					response?.data?.perfil?.telefone
				) {
					navigate("/resumo");
				} else if (
					response.data.usuario?.status == true &&
					(response.data.perfilAlreadyExists === false ||
						!response?.data?.perfil?.telefone)
				) {
					navigate("/cadastro");
				} else if (
					response.data.usuario?.status == false &&
					response.data.perfilAlreadyExists === true
				) {
					setAlert(true);
				}
			} else {
				localStorage.clear();

				setSnackbar({
					children: `Erro: senha ou login incorreto`,
					severity: "error",
				});
			}
		} catch (error) {
			if (error?.response?.status === 401) {
				setSnackbar({
					children: `Erro: senha ou login incorreto`,
					severity: "error",
				});
			} else if (error?.response?.status === 429) {
				const dataError = isValidJSON(error?.response?.data?.error)
					? JSON.parse(error?.response?.data?.error)
					: "";
				setSnackbar({
					children: `Erro: Muitas tentativas incorretas. Por favor aguarde ${
						dataError?.waitingTime || 5
					} minutos`,
					severity: "error",
				});
			} else {
				setSnackbar({
					children: `Falha ao tentar se conectar ao Servidor`,
					severity: "error",
				});
			}
			console.error(error);
		}
		setLoading(false);
	};

	const isValidJSON = (str) => {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			handleLogin();
		}
	};

	return (
		<>
			<Box sx={styles.container}>
				<Box sx={styles.form}>
					<Stack sx={styles.boxLogo}>
						<Icon sx={styles.logo}>
							<img src={logo} style={styles.img} alt="logo mw" />
						</Icon>
					</Stack>

					<Paper sx={styles.paperForm}>
						<Box sx={styles.boxForm}>
							<Box sx={styles.titleForm}>
								<Typography
									fontSize="1.7rem"
									color="text.primary"
									fontWeight={600}
								>
									Login
								</Typography>
								<Typography
									fontSize="1rem"
									color="text.secondary"
									fontWeight={400}
								>
									Bem vindo! Por favor digite suas credenciais.
								</Typography>
							</Box>
							<Box sx={styles.boxTextFields}>
								<TextField
									error={!login && Null}
									id="outlined-adornment-login"
									type="text"
									variant="outlined"
									onKeyDown={handleKeyDown}
									onChange={(event) => {
										setLogin(event.target.value);
									}}
									label="Login"
									helperText={!login && Null && "Login Inválido"}
									sx={styles.textField}
								/>
								<TextField
									error={!senha && Null}
									id="outlined-adornment-password"
									type={showPassword ? "text" : "password"}
									onKeyDown={handleKeyDown}
									variant="outlined"
									onChange={(event) => {
										setSenha(event.target.value);
									}}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													aria-label="toggle password visibility"
													onClick={() => setShowPassword((show) => !show)}
													onMouseDown={(event) => {
														event.preventDefault();
													}}
													edge="end"
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										),
									}}
									label="Password"
									helperText={!senha && Null && "Senha Inválida"}
									sx={styles.textField}
								/>
							</Box>

							<Box sx={styles.boxButtonAndLinks}>
								<Box sx={styles.link}>
									<Typography fontSize="1rem" color="text.secondary">
										Não está conseguindo acessar?{" "}
									</Typography>
									<Link
										href="/redefinirSenha"
										sx={{
											textDecoration: "none",
											fontSize: "1rem",
											fontWeight: 500,
										}}
									>
										{" "}
										Redefinir senha
									</Link>
								</Box>
								<Button
									variant="contained"
									disabled={loading}
									onClick={() => {
										handleLogin();
									}}
									sx={styles.button}
								>
									Entrar
								</Button>
								<Box
									sx={{
										width: "100%",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "column",
										gap: 1,
									}}
								>
									<Divider
										sx={{
											width: "100%",
											fontSize: "1rem",
											fontWeight: "600",
											color: "text.disabled",
										}}
									>
										redes sociais
									</Divider>
									<Box sx={styles.linkIcons}>
										<IconButton>
											<Facebook sx={styles.icons} />
										</IconButton>
										<IconButton>
											<LinkedIn sx={styles.icons} />
										</IconButton>
										<IconButton>
											<Instagram sx={styles.icons} />
										</IconButton>
										<IconButton>
											<Language sx={styles.icons} />
										</IconButton>
									</Box>
								</Box>
							</Box>
						</Box>
					</Paper>
				</Box>
			</Box>
			<Snackbar
				autoHideDuration={6000}
				open={alertOpen}
				onClose={() => {
					setAlertOpen(false);
				}}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="error">Erro: senha ou login incorreto</Alert>
			</Snackbar>

			{!!snackbar && (
				<Snackbar
					open
					onClose={() => setSnackbar(null)}
					autoHideDuration={6000}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					<Alert {...snackbar} onClose={() => setSnackbar(null)} />
				</Snackbar>
			)}
		</>
	);
}
